import { render, staticRenderFns } from "./companytag.vue?vue&type=template&id=1b6a547c&scoped=true"
var script = {}
import style0 from "./companytag.vue?vue&type=style&index=0&id=1b6a547c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a547c",
  null
  
)

export default component.exports